var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpGoodsimageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1018.4,596L876,453.6c-3.6-3.6-8.5-5.6-13.5-5.6H768v-64h112c8.8,0,16-7.2,16-16V80c0-8.8-7.2-16-16-16H400 c-8.8,0-16,7.2-16,16v288c0,8.8,7.2,16,16,16h112v64h-94.5c-5.1,0-10,2-13.5,5.6L261.6,596c-3.6,3.6-5.6,8.5-5.6,13.5v444.9 c0,5.1,2,10,5.6,13.6L404,1210.4c3.6,3.6,8.5,5.6,13.6,5.6h444.9c5.1,0,10-2,13.6-5.6l142.3-142.4c3.6-3.6,5.6-8.5,5.6-13.6V609.5 C1024,604.5,1022,599.6,1018.4,596z M448,320V128h384v192H448z M576,384h128v64H576V384z M960,1035.9L843.9,1152H436.1L320,1035.9 V628.1L436.1,512h407.8L960,628.1V1035.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M800,640H480c-17.7,0-32,14.3-32,32v320c0,17.7,14.3,32,32,32h320c17.7,0,32-14.3,32-32V672 C832,654.3,817.7,640,800,640z M768,960H512V704h256V960z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248,256H96c-17.7,0-32,14.3-32,32v704c0,17.7,14.3,32,32,32h88c4.4,0,8-3.6,8-8v-48c0-4.4-3.6-8-8-8h-56V320 h120c4.4,0,8-3.6,8-8v-48C256,259.6,252.4,256,248,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1184,256h-152c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8h120v640h-56c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8h88 c17.7,0,32-14.3,32-32V288C1216,270.3,1201.7,256,1184,256z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpGoodsimageNormal);
export default __webpack_public_path__ + "static/media/hp_goodsimage_normal.b4923b202db84d4ef24cbdf615caef54.svg";
export { ForwardRef as ReactComponent };